<template>
    <b-select placeholder="Выберите действие" expanded v-model="selectedAction">
        <option v-for="action in actions"
                :value="action.id"

                :key="action.id"
        >
            {{ title(action.name) }}
        </option>
    </b-select>
</template>

<script>
import promoActionRepository from "../../repository/promoActionRepository";

export default {
    props: {
        action: {
            type: [Number, String]
        }
    },
    data() {
        return {
            actions: [],
        }
    },
    computed: {
        selectedAction: {
            get() {
                return this.action;
            },
            set(value) {
                this.$emit('update:action', value)
            }
        },
    },
    methods: {
        fetchData() {
            promoActionRepository.list()
                .then(({data}) => {
                    this.actions = data;
                })
        },
        title(name) {
            const titles = {
                "DISH": "Блюдо",
                "COMBO": "Комбо",
                'LINK': "Ссылка",
                "NONE": "Ничего"
            };

            return titles[name];
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>

<style scoped>

</style>
